import { render } from "./ViewMoreDocuments.vue?vue&type=template&id=91838c5e&scoped=true&ts=true&lang=pug"
import script from "./ViewMoreDocuments.vue?vue&type=script&lang=ts"
export * from "./ViewMoreDocuments.vue?vue&type=script&lang=ts"

import "./ViewMoreDocuments.vue?vue&type=style&index=0&id=91838c5e&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91838c5e"]])

export default __exports__